import { useEffect, useState } from 'react';
import KaModal from '../../common/KaModal';
import { KaSelectOption, KaSelect, isMultiValue } from '../../common/KaSelect';
import { FilterSettings } from './StagedOrders';

export interface StagedOrderFilterModalProps {
  stagedOrderStepOptions: KaSelectOption[];
  bayOptions: KaSelectOption[];
  filters: FilterSettings;
  updateFilters: (settings: Partial<FilterSettings>) => void;
  toggle: () => void,
}

const StagedOrderFilterModal = ({
  stagedOrderStepOptions,
  bayOptions,
  filters,
  updateFilters,
  toggle,
}: StagedOrderFilterModalProps) => {
  const [selectedStagedOrderStep, setSelectedStagedOrderStep] = useState<string>(filters.stagedOrderStep);
  const [selectedBay, setSelectedBay] = useState<string>(filters.bay);

  useEffect(() => {
    setSelectedStagedOrderStep(filters.stagedOrderStep);
    setSelectedBay(filters.bay);
  }, [filters]);

  const handleFilter = () => {
    updateFilters({
      stagedOrderStep: selectedStagedOrderStep,
      bay: selectedBay,
    });
    toggle();
  };

  return (
    <KaModal
      isOpen={true}
      toggle={toggle}
      title={"Filter Staged Orders"}
      body={
        <div>

          <div className="row">
            <h5>Status:</h5>
            <KaSelect
              onChange={(valueObject) => {
                if (!isMultiValue(valueObject)) {
                  setSelectedStagedOrderStep(valueObject?.value!);
                }
              }}
              placeholder="Select status"
              isClearable={true}
              options={stagedOrderStepOptions}
              value={stagedOrderStepOptions.find((option) => option.value === selectedStagedOrderStep)} />
          </div>

          <div className="row mt-3">
            <h5>Bay:</h5>
            <KaSelect
              onChange={(valueObject) => {
                if (!isMultiValue(valueObject)) {
                  setSelectedBay(valueObject?.value!);
                }
              }}
              placeholder="Select bay"
              isClearable={true}
              options={bayOptions}
              value={bayOptions.find((option) => option.value === selectedBay)} />
          </div>
        </div>
      }
      footer={
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleFilter}>
          Filter
        </button>
      }
    />
  );
};

export default StagedOrderFilterModal;